'use client';

import { createContext, useContext, type ReactNode } from 'react';

const SiteUrlContext = createContext<string>('');

export function SiteUrlProvider({
  siteUrl,
  children,
}: {
  siteUrl: string;
  children: ReactNode;
}) {
  return <SiteUrlContext value={siteUrl}>{children}</SiteUrlContext>;
}

export function useSiteUrl() {
  return useContext(SiteUrlContext);
}
